// The product's name, written once (D300), here because every layer may import this package: a
// contract's error message, an email a rules file writes, a screen through `@amtana/i18n`'s
// `{product}`. Renaming the product is this line and `pnpm generate:brand`, which redraws the
// wordmark and the downloadable kit.

export const PRODUCT_NAME = "Zaistev";

/** Where a reader writes to the people behind the product: the site's footer, the brand page. */
export const CONTACT_ADDRESS = "hello@mail.zaistev.com";

/** The name as a file name carries it: the brand kit's `<slug>-logo-light.svg`. */
export const PRODUCT_SLUG = PRODUCT_NAME.toLowerCase()
  .normalize("NFD")
  .replace(/[^a-z0-9]+/g, "-")
  .replace(/^-|-$/g, "");
